import React, { FC } from 'react';

import { wrap } from '@sitecore/common';
import type { TextStreamerRendering } from '@sitecore/types/TextStreamer';
import { Box, Stack, Text } from '@sparky';

const TextStreamer: FC<TextStreamerRendering> = ({ fields }) => {
  const { streamerSubText, title } = fields;
  return (
    <Box paddingTop="10" paddingBottom="6">
      <Stack gap="5">
        {(title?.value || title?.editable) && (
          <Text size={{ initial: 'QuoteS', md: 'QuoteM' }} color="textBrand" weight="regular">
            {wrap(title)}
          </Text>
        )}
        {(streamerSubText?.value || streamerSubText?.editable) && (
          <Text size={{ initial: 'BodyM', md: 'BodyL' }} color="textLowEmphasis">
            {wrap(streamerSubText)}
          </Text>
        )}
      </Stack>
    </Box>
  );
};

export default TextStreamer;
